import { fedopsLogger } from '../fedops'
import withMonitoringFactory from './withMonitoring.factory'

export const withMonitoring = withMonitoringFactory(fedopsLogger)
